module.exports = __webpack_public_path__ + "static/media/404.e5e08656.svg";